require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./flyout"), require("./svgicon"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./flyout", "./svgicon", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./flyout"), require("./svgicon"), require("./utils")) : factory(root["./flyout"], root["./svgicon"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__7662__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[2405],{

/***/ 85440:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _flyout = _interopRequireDefault(__webpack_require__(7662));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _baUiCarbon = __webpack_require__(6536);
var _utils = __webpack_require__(78815);
var _IconPicker = _interopRequireDefault(__webpack_require__(41128));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: @ba/ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const iconpickerClassName = _IconPicker.default.iconpickerClassName.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;
const {
  uniqueId
} = _utils.lodash;
class IconPicker extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_handleOpen", () => {
      this.setState(state => ({
        open: !state.open
      }));
    });
    this.state = {
      open: false
    };
    this._handleSelect = this._handleSelect.bind(this);
    this._handleKey = this._handleKey.bind(this);
    this._id = uniqueId('ba-common-icon-picker__');
    this.attachRef = _react.default.createRef();
  }
  _handleOpenOnKeydown(e) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      this._handleOpen();
    }
  }
  _handleSelect(iconSpec) {
    this.props.onIconSelected(iconSpec);
    // close the flyout after selection
    this.setState(state => ({
      open: !state.open
    }));
  }
  _handleKey(e, iconSpec) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      this._handleSelect(iconSpec);
      // Prevent browser's default action: space does a PageDown
      e.preventDefault();
    }
  }
  _displayIcon(iconSpec, index) {
    if (iconSpec === void 0) {
      iconSpec = {};
    }
    const {
      iconExtraOptions
    } = this.props;
    const {
      className,
      size,
      tabIndex,
      verticalAlign,
      ...others
    } = iconExtraOptions;
    const {
      icon
    } = iconSpec;
    const displayGhostButton = icon.id === 'none';
    const classnames = (0, _utils.classnames)(displayGhostButton ? `${iconpickerClassName}__text` : `${iconpickerClassName}__cell`, `${className}`);
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      key: index,
      tabIndex: tabIndex,
      className: classnames,
      onClick: () => this._handleSelect(iconSpec),
      onKeyDown: e => this._handleKey(e, iconSpec),
      title: iconSpec.label
    }, sanitize(others, IconPicker)), displayGhostButton ? /*#__PURE__*/_react.default.createElement(_baUiCarbon.Button, {
      kind: "ghost",
      size: "small",
      tabIndex: tabIndex,
      className: `${iconpickerClassName}__ghost`,
      onClick: () => this._handleSelect(iconSpec),
      onKeyDown: e => this._handleKey(e, iconSpec)
    }, iconSpec.label) : /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      iconId: icon.id,
      alt: iconSpec.label,
      ariaLabelledby: uniqueId('icon-picker-svg'),
      size: size,
      verticalAlign: verticalAlign
    }));
  }
  render() {
    const {
      open
    } = this.state;
    const {
      className,
      disabled,
      icons,
      selectedIcon,
      style,
      buttonExtraOptions,
      flyoutExtraOptions,
      ...others
    } = this.props;
    let {
      orientation
    } = this.props;
    if (typeof orientation === 'undefined') {
      orientation = document.body.dir === 'rtl' ? 'bottomLeft' : 'bottomRight';
    }
    const classNames = `${iconpickerClassName}${className.length > 0 ? ` ${className}` : ''}${selectedIcon.icon.id === '' ? ` ${iconpickerClassName}__none` : ''}`;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, IconPicker), {
      className: classNames,
      ref: this.attachRef,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_svgicon.default, (0, _extends2.default)({
      tabIndex: 0,
      "data-tid": "ba-common-icon-picker__button",
      disabled: disabled,
      className: `${iconpickerClassName}__svgIcon`,
      iconId: selectedIcon.icon.id,
      onClick: !disabled ? this._handleOpen : undefined,
      onKeyDown: !disabled ? e => this._handleOpenOnKeydown(e) : undefined
    }, buttonExtraOptions)), open && /*#__PURE__*/_react.default.createElement(_flyout.default, (0, _extends2.default)({
      id: `${this._id}-flyout`,
      "data-tid": "ba-common-icon-picker__flyout"
    }, flyoutExtraOptions, {
      "aria-hidden": open,
      placement: orientation,
      domNodeToAttachTo: this.attachRef.current,
      hideArrow: true,
      offset: 2,
      onClose: this._handleOpen,
      className: `${iconpickerClassName}__flyout`
    }), icons.map(this._displayIcon.bind(this))));
  }
}
exports["default"] = IconPicker;
(0, _defineProperty2.default)(IconPicker, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** Flag to disable the icon picker */
  disabled: _propTypes.default.bool,
  /** Icons to be selected */
  icons: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.shape({
      id: _propTypes.default.string.isRequired
    }).isRequired,
    iconId: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  })).isRequired,
  /** Flyout.propTypes.placement */
  orientation: _flyout.default.propTypes.placement,
  /** Function that will get called on click of a icon */
  onIconSelected: _propTypes.default.func.isRequired,
  /** Selected icon to show */
  selectedIcon: _propTypes.default.shape({
    icon: _propTypes.default.shape({
      id: _propTypes.default.string.isRequired
    }).isRequired,
    iconId: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  }).isRequired,
  /** Custom css styles */
  style: _propTypes.default.object,
  /** Extra options for the svg click to open/close the flyout */
  buttonExtraOptions: _propTypes.default.object,
  /** Extra options for the svg to pass to Flyout */
  iconExtraOptions: _propTypes.default.shape({
    className: _propTypes.default.string,
    size: _propTypes.default.string,
    tabIndex: _propTypes.default.number,
    verticalAlign: _propTypes.default.string
  }),
  /** Extra options to pass to Flyout */
  flyoutExtraOptions: _propTypes.default.object
});
(0, _defineProperty2.default)(IconPicker, "defaultProps", {
  disabled: false,
  className: '',
  style: {},
  buttonExtraOptions: {},
  iconExtraOptions: {
    tabIndex: 0,
    className: '',
    verticalAlign: 'inherit'
  },
  flyoutExtraOptions: {}
});

/***/ }),

/***/ 50151:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _IconPicker = _interopRequireDefault(__webpack_require__(85440));
exports["default"] = _IconPicker.default;
exports.IconPicker = _IconPicker.default;

/***/ }),

/***/ 80266:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-iconpicker{position:relative;display:flex;height:24px;width:24px;font-size:.875rem;background-color:#fff;background-color:hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1)}.ba-common-iconpicker .ba-common-iconpicker__svgIcon{margin:auto}.ba-common-iconpicker__none{background-image:repeating-linear-gradient(135deg, white 0%, white 48%, red 50%, white 52%, white 100%);background-repeat:no-repeat}.ba-common-iconpicker__flyout{padding:.3em;width:200px;flex-wrap:wrap;display:flex;justify-content:flex-start;-ms-high-contrast-adjust:none}.ba-common-iconpicker__cell{display:inline-block;width:16px;height:16px;margin:8px}.ba-common-iconpicker__cell:hover{cursor:pointer}.ba-common-iconpicker__text{width:100%;height:100%;text-align:center}.ba-common-iconpicker__text:hover{cursor:pointer}.ba-common-iconpicker .ba-common-iconpicker__ghost{width:100%;height:100%;display:flex;justify-content:center;color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1)}.ba-common-iconpicker .ba-common-iconpicker__ghost:hover{background-color:#fff;background-color:hsla(var(--icon-03-h, 0), var(--icon-03-s, 0%), var(--icon-03-l, 100%), 1);color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.6274509804%), 1)}", ""]);

// exports
exports.locals = {
	"iconpickerClassName": "\"ba-common-iconpicker\""
};

/***/ }),

/***/ 41128:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80266);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_IconPicker_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 7662:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7662__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(50151));
/******/ return __webpack_exports__;
/******/ }
]);
});